/** 图标组件 */
import { memo, createElement } from 'react';
import classname from 'classnames';
import "./index.scss";
const Icon = ({
  tag = 'i',
  name,
  size,
  style,
  ...other
}) => {
  const props = {
    ...other,
    style: {
      ...style
    }
  };
  if (typeof size === 'number') {
    props.style.fontSize = size;
  }
  props.className = classname('cc-icon iconfont', `icon-${name}`, props.className, typeof size === 'string' ? `size-${size}` : '');
  return /*#__PURE__*/createElement(tag, props);
};
Icon.displayName = 'cc-icon';
export default /*#__PURE__*/memo(Icon);